import { Circle } from 'lucide-react'
import React from 'react'
import Heading from './template/Heading'
import GotoEndpoint from './template/GotoEndpoint'
import tuhinLogo from '../assets/tuhinlogo.png'

function Banner() {
    return (
        <section className="grid min-h-[calc(100vh-5rem)] w-full grid-cols-1 items-center gap-12 py-8 sm:py-10 lg:max-h-screen lg:grid-cols-2 lg:gap-0 lg:py-0">

            <h3 className='order-3 flex items-center justify-center gap-3 text-xs uppercase tracking-[0.35em] text-primary sm:text-sm lg:absolute lg:-right-35 lg:top-1/6 lg:z-10 lg:-translate-y-1/2 lg:-rotate-90 lg:justify-start lg:whitespace-nowrap'><Circle strokeWidth="6" className='rounded-full animate-ping' size={12} /> <span>Open To Freelance Work</span></h3>


            <div className='order-1 pt-6 text-center capitalize  lg:text-left'>
                <Heading tag="h1" className="max-w-[10ch] mx-auto lg:mx-0">
                    hello, i'm <br /> <span className='text-secondary'>Tuhin Kairi.</span>
                </Heading>
                <p className='mx-auto mt-5 mb-8 w-full max-w-xl leading-7 text-secondary text-lg sm:mt-6 sm:mb-10 lg:w-2/3 sm:text-[1.25rem] lg:mx-0 lg:text-primary'>I'm A passionate FullStack developer and AI/ML Enthusiast from India.</p>
                <GotoEndpoint content="View My Work" endpoint="/myworks" className="inline-flex items-center text-base sm:text-lg" />
            </div>
            <div className='order-2 grid items-end'>
                {/* <div className='absolute min-h-12 lg:min-h-0 '> */}
                {/* </div> */}
                <div className='mx-auto w-full max-w-sm text-center text-sm leading-6 text-secondary sm:w-2/3 lg:mx-auto lg:w-1/2 lg:max-w-none lg:text-left xl:w-1/3 relative grid items-center justify-center'>
                    <img loading="lazy" src={tuhinLogo} alt="logo" className='mx-auto h-28 w-auto sm:h-36 xl:h-40 xl:animate-[bounce_8s_linear_infinite] relative z-0' />

                    <div className="mt-4 border-t-2 border-secondary pt-4">
                        <span>I build thoughtful digital products that balance clean interfaces, solid architecture, and measurable business value.</span>
                        <br />
                        <br />
                        <span>From fast portfolio builds to AI-assisted workflows and production-ready platforms, the goal is always clarity, speed, and reliability.</span>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default Banner
